import { render, staticRenderFns } from "./review-card-list-loader.vue?vue&type=template&id=824f9340&scoped=true"
import script from "./review-card-list-loader.vue?vue&type=script&lang=js"
export * from "./review-card-list-loader.vue?vue&type=script&lang=js"
import style0 from "./review-card-list-loader.vue?vue&type=style&index=0&id=824f9340&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824f9340",
  null
  
)

export default component.exports